import ThankYou from './ThankYou'
import SuccessToast from './SuceessToast'

export { SuccessToast }
export default ThankYou